import React from 'react';

let s = {
  text: {
    fontSize: 11,
    fontWeight: 600,
    verticalAlign: 'middle',
  },
  sessionTime: {
    color: '#999',
    fontSize: 9,
    verticalAlign: 'middle',
    marginLeft: 2,
  },
  container: {
    display: 'block',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    marginBottom: 4,
  },
};

const Circle = ({ backgroundColor }) => {
  return (
    <div
      style={{
        marginRight: 2,
        display: 'inline-block',
        height: 6,
        width: 6,
        borderRadius: '50%',
        backgroundColor,
      }}
    />
  );
};

class DateCell extends React.PureComponent {
  render() {
    return (
      <div className="events">
        {this.props.listData.map(item => {
          return (
            <div
              key={item._id}
              role="button"
              tabIndex={0}
              onClick={() => {
                this.props.selectSession(item);
                this.props.toggleModal();
              }}
            >
              <span style={s.container}>
                <Circle backgroundColor={item.sessionType.color} />
                <span style={s.text}>{item.sessionType.title}</span>
                <span style={s.sessionTime}> {item.sessionTime && ` ${item.sessionTime}`}</span>
              </span>
            </div>
          );
        })}
      </div>
    );
  }
}

export default DateCell;



// WEBPACK FOOTER //
// ./src/components/common/NedCalendar/DateCell/index.js